import styled, { css } from 'styled-components';
import Tab from '@material-ui/core/Tab';

export const HistorieHeader = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  letter-spacing: 0.03em;
  color: #3699ff;
  padding: 10px 8px;
  border-bottom: 1px solid #e5eaee;
  > div {
    cursor: pointer;
  }

  svg.arrow {
    margin-left: 10px;
    transition: all ease-in-out 0.35s;
    transform: rotate(0);
    &-up {
      transform: rotate(-180deg);
    }
  }
`;
export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;
export const ListItem = styled.li<{ selected: boolean; isPointer?: boolean }>`
  font-weight: 500;
  border-bottom: 1px solid #e5eaee;
  font-size: 13px;
  line-height: 19px;
  color: #b5b5c3;
  transition: background-color ease-in 0.3s;
  padding: 8px;
  ${({ isPointer }) =>
    isPointer &&
    css`
      cursor: pointer;
      &:hover {
        background-color: ${(props) => props.theme.colors.malibu01};
      }
    `}}


  ${({ selected, isPointer }) =>
    selected &&
    isPointer &&
    css`
      cursor: no-drop;
      background: #eaedf2;
      &:hover {
        background: #eaedf2;
      }
    `}
`;
export const ItemTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #3699ff;
`;

export const HeadTab = styled(Tab)`
  && {
    color: #6c7293;
    font-weight: 500;
    font-size: 13px;
    line-height: 19px;
    padding: 8px;
    margin: 8px;
    border-radius: 4px;
    transition: all ease-in 0.3s;

    &.Mui-selected {
      background-color: ${(props) => props.theme.colors.mainlyblue};
      color: ${(props) => props.theme.colors.malibu};
    }
  }
`;

export const TooltipButton = styled.button<{ show: boolean; noBorder: boolean }>`
  color: ${(props) => props.theme.colors.malibu};
  background-color: transparent;
  border: ${(props) => (props.noBorder ? 'none' : '1px solid transparent')};
  cursor: ${(props) => (props.noBorder ? 'initial !important' : 'pointer')};
  padding: 3.5px 8px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  height: 25px;
  width: 34px;
  transition: all ease-in-out 0.5s;
  overflow: hidden;
  flex-wrap: nowrap;
  word-wrap: break-word;

  .wrapp {
    padding: 0;
  }

  > span {
    padding-left: 8px;
    opacity: 0;
    font-weight: 500;
    font-size: 11px;
    line-height: 16px;
    transition: opacity ease-in-out 0.4s;
    white-space: nowrap;
  }

  &:hover,
  &:active {
    width: auto;
    background-color: ${(props) => props.theme.colors.paleBlue};
    border-color: ${(props) => props.theme.colors.malibu};
    > span {
      opacity: 1;
    }
  }

  ${({ show }) =>
    show &&
    css`
      width: auto;
      background-color: ${(props) => props.theme.colors.paleBlue};
      border-color: ${(props) => props.theme.colors.malibu};
      > span {
        opacity: 1;
      }
    `}
`;

export const Title = styled.div`
  color: #000000;
  display: flex;
  font-size: 24px;
  line-height: 36px;
`;
